export default "/images/ecbcaf8da67b936b2a64d7b7625d642a.avif";